export enum ErrorMessage {
    NonUnique = 'NON_UNIQUE_PROPERTIES',
    ContactIsAssignedAsMainContact = 'CONTACT_IS_ASSIGNED_AS_MAIN_CONTACT',
}
